import { createSlice } from '@reduxjs/toolkit';

import { STATUS } from '@constants/status';

export const initialState = {
  model: [],
  meta: {
    errorMessage: '',
    status: STATUS.SUCCESS,
  },
};

const jurisdictions = createSlice({
  name: 'jurisdictions',
  initialState,
  reducers: {
    reset: () => initialState,
    request: state => {
      state.meta.errorMessage = '';
      state.meta.status = STATUS.LOADING;
    },
    success: (state, action) => {
      state.meta.status = STATUS.SUCCESS;
      state.model = action.payload;
    },
    failure: (state, action) => {
      state.meta.status = STATUS.ERROR;
      state.meta.errorMessage = action.payload.errorMessage;
    },
  },
});

export const {
  reset: jurisdictionsReset,
  request: jurisdictionsRequest,
  success: jurisdictionsSuccess,
  failure: jurisdictionsFailure,
} = jurisdictions.actions;

export default jurisdictions.reducer;
